<template>
    <div class="d-flex align-items-center my-3">
        <span class="darker font-weight-600 mr-2" @click="testCalc">
            Seller:
        </span>
        <!-- <v-select
            v-model="reservation.agent"
            :options="editedAgentList"
            placeholder="- Select person -"
            :searchable="true"
            label="brandName"
            @input="updateSeller">
        </v-select> -->

        <seller-picker class="w-100" @allDownloaded="sellersLoaded" :reservation="reservation" :orignalSeller="reservation.creatorAgent? reservation.creatorAgent : account" :agentList="eventPossibleAgentsList(reservation.event)" @input="sellerChanged"></seller-picker>

        <!-- <button class="btn" @click="testCalc">test</button> -->
    </div>
</template>

<script>
import SellerPicker from '../../../../../tools/SellerPicker'
import { eventMixin } from '@/mixins/event'

import extendedVSelect from '@/extends/vue-select'
import {mapActions, mapGetters} from 'vuex'

export default {
    mixins: [
        eventMixin
    ],
    data: function() {
        return {
            selectedAgent: null,
        }
    },
    props: {
        reservation: {
            type: Object,
        },
        selectedAgentComissions: {
            type: Object,
            default: null
        }
    },
    created: function() {
        //set default seller as me
        this.reservation.creatorUserAccount = this.account
        this.$set(this.reservation, 'creatorSupplier', this.account.supplier)

        // this.initAgents().then(response => {
            this.reservation.agent = this.agentMe
        // });
    },
    computed: {
        ...mapGetters([
            'getAgents',
            'account'
        ]),
        editedAgentList: function() {
            let agentList = JSON.parse(JSON.stringify(this.getAgents));

            let agentMustHaveName = agentList.filter(agent => {
                return agent.name != null
            })

            agentMustHaveName.unshift(this.agentMe)

            return agentMustHaveName;
        },
        agentMe: function() {
            return {brandName: this.account.name + ' (Me)', id: null}
        }
    },
    methods:{
        ...mapActions([
            // 'initAgents',
            'setReservationCalculations',
            'resetCalculationsGuid'
        ]),
        testCalc: function(){
            this.setReservationCalculations(this.reservation)
        },
        updateSeller: function() {
            //DISCONTINUED
            // this.$set(this.reservation, 'creatorUserAccount', this.account)
            if(this.reservation.agent.id){
                //is agent
                this.getSelectedUserComissions();
                // this.creatorAgent = this.reservation.agent
                // this.$set(this.reservation, 'creatorSupplier', null)
                this.$set(this.reservation, 'creatorAgent', this.reservation.agent)
                // this.$set(this.reservation, 'creatorUserAccount', this.reservation.agent)
                // this.$set(this.reservation, 'creatorUserAccount', null)
            } else {
                //is me or my team
                // this.$set(this.reservation, 'creatorSupplier', this.account.supplier)
                this.$set(this.reservation, 'creatorAgent', null)
                this.$set(this.reservation.billing, 'agentCommision', null)
            }

            this.setReservationCalculations(this.reservation)

            // Sending full object as per API specifications instead of just ID

            // this.$emit('updateFields', { agent:
            //     {
            //         id: this.selectedAgent.id,
            //         name: this.selectedAgent.name
            //     }
            // });
        },
        sellerChanged: function(selectedSeller) {
            this.resetCalculationsGuid()
            this.reservation.calculationsGUID = null

            this.reservation.agent = selectedSeller
            // this.getSelectedUserComissions().then(response => {
            //     this.setReservationCalculations(this.reservation)
            // })
            this.setReservationCalculations(this.reservation)
        },
        getSelectedUserComissions: function(){
            return axios.get('/api/people/GetAgentCommissions', {
                params: {
                    supplierId: this.account.supplierId,
                    agentId: this.reservation.agent.id
                }
            }).then(response => {
                return response
                if(response.status && response.status == 200){
                    this.setAgentCommision(response.data)
                    // this.$emit('agentComissionsChanged', response.data)
                    // this.selectedAgentComissions = response.data;
                }
            })
        },
        setAgentCommision: function(commisions) {
            let agentCommision = commisions.defaultCommision

            for(let commisionRelation of commisions.commissionRelations){
                if(commisionRelation.productId == this.reservation.product.id){
                    agentCommision = commisionRelation.commissionValue;
                }
            }

            this.$set(this.reservation.billing, 'agentCommision', agentCommision)
        },
        sellersLoaded: function () {
            this.setReservationCalculations(this.reservation);
        }
    },
    components:{
        vSelect: extendedVSelect,
        SellerPicker
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// AgentSelector.vue?ad5d3942